import { Cache } from "memory-cache";
import { CharacterIndustryJobEntity } from ".";

// Cache
const cache = new Cache();
export async function getCachedCharacterIndustryJobEntity(job_id: number): Promise<CharacterIndustryJobEntity | null> {
  let entity: any = await cache.get(job_id.toString());
  if (entity) {
    return entity;
  }
  return null;
}
export function setCachedCharacterIndustryJobEntity(characterIndustryJob: CharacterIndustryJobEntity) {
  cache.put(characterIndustryJob.props.job_id.toString(), characterIndustryJob, 5 * 60 * 1000 /* 5 minutes */);
}
